import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'advanced-filters',
  templateUrl: './advanced-filters.component.html',
  styleUrls: ['./advanced-filters.component.scss'],
})
export class AdvancedFiltersComponent implements OnChanges {
  @Input() filter: any;
  @Input() embeddedComponent = false;
  @Output() filterSelectedEE = new EventEmitter<any>();

  show: boolean;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filter.currentValue) {
      if (changes.filter.currentValue?.dropdownFields.some((d) => d.selected)) {
        this.show = true;
      }
    }
  }

  selectFilter(event, item) {
    this.filter.dropdownFields.find((x) => x.value == event.target.value).selected =
      event.target.checked;

    const selectedValues = this.filter.dropdownFields
      ?.filter((x) => x.selected)
      .map((x) => x['value']);

    this.filterSelectedEE.emit({ value: selectedValues, filter: item });
  }

  toggleFilter() {
    this.show = !this.show;
  }

  collapse(): void {
    this.show = false;
  }
}
